module.exports = __webpack_public_path__ + "static/assets/084f2bac1a831866f24d9ca537034a0c.svg";